<template>
  <b-container>
    <b-row>
      <b-col cols="12" class="mb-4">
        <h3>
          <translate>Stores/Branches/Warehouses Management</translate>
          <b-button size="sm" variant="success" v-b-modal.modalStoreForm>
            <font-awesome-layers full-width class="fa-1x">
              <font-awesome-icon icon="store"/>
              <font-awesome-icon icon="plus" class="text-success" transform="up-9 right-14" />
              <font-awesome-icon icon="plus" transform="shrink-7 up-9 right-14" />
            </font-awesome-layers>
            &nbsp;&nbsp;&nbsp;<translate>New Store/Branch/Warehouse</translate>
          </b-button>
        </h3>
        <p class="my-4" v-translate>Here you can create and manage all your company's stores, branches, wharehouses or other locations with their business hours and contact persons to easily re-use them when posting a new shipping. All locations will be shared with and available to all users on your company into the address form inputs.</p>
      </b-col>
    </b-row>
    <b-row v-if="stores && stores.length > 0">
      <b-col sm="6" lg="4" v-for="(store, index) in stores" :key="index">
        <b-card class="text-center">
          <font-awesome-layers class="fa-4x mb-3">
            <font-awesome-icon icon="circle" />
            <font-awesome-icon icon="store" transform="shrink-7 left-2" style="color: white;" />
          </font-awesome-layers>
          <b-card-title class="mb-2">{{store.reference}}</b-card-title>
          <b-card-text>
            <div class="mb-3"><font-awesome-icon class="text-secondary " icon="map-marker-alt" /> {{store.place.formatted_address}}</div>
            <b-button size="sm" variant="link" class="text-danger" @click="deleteStore(store)" v-b-tooltip.hover :title="$gettext('Delete')">
              <font-awesome-icon icon="trash-alt" size="2x" />
            </b-button>
            <b-button size="sm" variant="link" class="text-primary" @click="storeEdit = store" v-b-modal.modalStoreForm v-b-tooltip.hover :title="$gettext('Edit')">
              <font-awesome-layers class="fa-2x">
                <font-awesome-icon icon="store"/>
                <font-awesome-icon icon="pen" class="text-white" transform="down-1 right-14" />
                <font-awesome-icon icon="pen" transform="shrink-7 down-3 right-12" />
              </font-awesome-layers>
            </b-button>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12">
        <span v-translate>No Stores/Branches/Warehouses here... yet.</span>
      </b-col>
    </b-row>

    <div class="d-none">
      <translate>Delete</translate>
    </div>

    <b-modal size="lg" id="modalStoreForm" ref="modalStoreForm" :hide-footer="true" @hide="storeEdit = {}; fetchStores()">
      <div slot="modal-title"><span v-if="storeEdit.id" v-translate>Edit</span><span v-else v-translate>New</span></div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <store-form :store="storeEdit || false" />
    </b-modal>
</b-container>
</template>
<script>
import StoreForm from '@/components/StoreForm'

export default {
  name: 'StoresManagementPage',
  title() {
    return this.$gettext('Stores Management')
  },
  components: {
    StoreForm
  },
  data() {
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      stores: [],
      storeEdit: {}
    }
  },
  mounted() {
    this.fetchStores()
  },
  methods: {
    fetchStores() {
      this.$store.dispatch('fetchProfile')
        .then(response => {
          this.stores = this.profile.company.stores
          // this.$store.commit('setEmail', this.user.email)
          // let payload = { profile: this.user }
          // this.$store.commit('setProfile', payload)
          // if (this.user.profile_address_id === null) {
          //   this.user.profile_address = {
          //     place: {
          //       formatted_address: null
          //     }
          //   }
          // }
          if (this.profile.company.stores.length > 0) {
            localStorage.setItem('companyStores', JSON.stringify(this.profile.company.stores))
          } else {
            localStorage.removeItem('companyStores')
          }
          this.storesUpdated = true
        })
    },
    deleteStore(store) {
      let translate = this.$gettext('Are you sure you want to DELETE the Store/Branch/Warehouse %{storeReference}? Please be careful, this action CANNOT be undone.')
      if (confirm(this.$gettextInterpolate(translate, {storeReference: store.reference})) === true) {
        this.$http.delete(this.$appConfig.api.baseUrl + 'companies/' + this.profile.company_id + '/stores/' + store.id)
          .then(response => {
            this.fetchStores()
          })
      }
    }
  }
}

</script>
